import React from "react";
import LoginForm from "../login-form";
import { useAppSelector } from "src/redux/redux-hooks";

const LoginView: React.FC = () => {
  const { artifacts } = useAppSelector((state) => state.app);

  return (
    <section className="login-mn">
      <div className="log-logo m-b-20">
        <img
          src={artifacts?.logo}
          alt="Logo"
          style={{
            maxWidth: "250px",
            maxHeight: "100px",
            visibility: artifacts?.logo ? "visible" : "hidden",
            minHeight: "60px",
          }}
        />
      </div>
      <div className="log-fld">
        <h2 className="text-center">Sign In</h2>
        <LoginForm />
      </div>
    </section>
  );
};

export default LoginView;
